import React, { useEffect, useState } from 'react';

import axios from 'axios';

import { toast } from 'react-toastify';

import { FiX, FiCopy, FiEdit, FiTrash2, FiPlus, FiCheck, FiFile } from 'react-icons/fi';

import { useAuth } from '../contexts/AuthContext';

import './FileShareModal.css';



const FileShareModal = ({ open, onClose, companyFile }) => {

  const { isModerator } = useAuth();

  const [links, setLinks] = useState([]);

  const [loading, setLoading] = useState(false);

  const [showCreateForm, setShowCreateForm] = useState(false);

  const [editingLink, setEditingLink] = useState(null);

  const [formData, setFormData] = useState({

    name: '',

    password: '',

    has_password: false,

    expires_at: '',

    expires_at_time: '',

  });



  useEffect(() => {

    if (open && companyFile?.id) {

      fetchLinks();

      resetForm();

    }

  }, [open, companyFile?.id]);



  const fetchLinks = async () => {

    if (!companyFile?.id) return;

    setLoading(true);

    try {

      const response = await axios.get(`/api/files/${companyFile.id}/share-links/`);

      setLinks(Array.isArray(response.data) ? response.data : []);

    } catch (error) {

      toast.error('Ошибка загрузки ссылок');

    } finally {

      setLoading(false);

    }

  };



  const resetForm = () => {

    setFormData({

      name: '',

      password: '',

      has_password: false,

      expires_at: '',

      expires_at_time: '',

    });

    setEditingLink(null);

    setShowCreateForm(false);

  };



  const buildExpiresAt = () => {

    if (!formData.expires_at) return null;

    const time = formData.expires_at_time || '23:59';

    return new Date(`${formData.expires_at}T${time}`).toISOString();

  };



  const handleSubmit = async (e) => {

    e.preventDefault();

    const payload = {

      name: formData.name.trim() || companyFile.original_filename,

      expires_at: buildExpiresAt(),

      is_active: true,

    };

    if (formData.has_password && formData.password) {

      payload.password = formData.password;

    } else if (editingLink && !formData.has_password) {

      payload.password = '';

    }

    try {

      if (editingLink) {

        await axios.put(`/api/files/${companyFile.id}/share-links/${editingLink.id}/`, payload);

        toast.success('Ссылка обновлена');

      } else {

        await axios.post(`/api/files/${companyFile.id}/share-links/`, payload);

        toast.success('Ссылка создана');

      }

      resetForm();

      fetchLinks();

    } catch (error) {

      toast.error(error.response?.data?.error || 'Ошибка сохранения ссылки');

    }

  };



  const handleEdit = (link) => {

    const expiresDate = link.expires_at ? new Date(link.expires_at) : null;

    setEditingLink(link);

    setShowCreateForm(true);

    setFormData({

      name: link.name || '',

      password: '',

      has_password: !!link.has_password,

      expires_at: expiresDate ? expiresDate.toISOString().slice(0, 10) : '',

      expires_at_time: expiresDate ? expiresDate.toTimeString().slice(0, 5) : '',

    });

  };



  const handleDelete = async (link) => {

    if (!window.confirm('Удалить ссылку?')) return;

    try {

      await axios.delete(`/api/files/${companyFile.id}/share-links/${link.id}/`);

      toast.success('Ссылка удалена');

      fetchLinks();

    } catch (error) {

      toast.error('Ошибка удаления ссылки');

    }

  };



  const copyLink = async (link) => {

    const url = link.full_url || `${window.location.origin}/files/share/${link.slug}/`;

    try {

      await navigator.clipboard.writeText(url);

      toast.success('Ссылка скопирована');

    } catch (error) {

      toast.error('Не удалось скопировать ссылку');

    }

  };



  if (!open || !companyFile) return null;



  return (

    <div className="modal-overlay" onClick={onClose}>

      <div className="modal-content file-share-modal" onClick={(e) => e.stopPropagation()}>

        <div className="modal-header file-share-header">

          <h2>Поделиться файлом</h2>

          <button type="button" className="file-share-close" onClick={onClose} aria-label="Закрыть">

            <FiX />

          </button>

        </div>



        <div className="file-share-body">

          <div className="file-share-file">

            <div className="file-share-file-icon" aria-hidden="true">

              <FiFile />

            </div>

            <div className="file-share-file-name" title={companyFile.original_filename}>

              {companyFile.original_filename}

            </div>

          </div>



          <section className="file-share-section">

            {!showCreateForm ? (

              <button type="button" className="file-share-create-btn" onClick={() => setShowCreateForm(true)}>

                <FiPlus />

                <span>Создать ссылку</span>

              </button>

            ) : (

              <form className="file-share-form" onSubmit={handleSubmit}>

                <div className="file-share-form-title">

                  {editingLink ? 'Редактирование ссылки' : 'Новая ссылка'}

                </div>

                <label className="file-share-field">

                  <span className="file-share-label">Название</span>

                  <input

                    className="form-input"

                    placeholder="Например: для клиента"

                    value={formData.name}

                    onChange={(e) => setFormData({ ...formData, name: e.target.value })}

                  />

                </label>

                <label className="file-share-checkbox">

                  <input

                    type="checkbox"

                    checked={formData.has_password}

                    onChange={(e) => setFormData({ ...formData, has_password: e.target.checked })}

                  />

                  <span>Защитить паролем</span>

                </label>

                {formData.has_password && (

                  <label className="file-share-field">

                    <span className="file-share-label">Пароль</span>

                    <input

                      type="password"

                      className="form-input"

                      placeholder={editingLink ? 'Новый пароль (пусто — не менять)' : 'Введите пароль'}

                      value={formData.password}

                      onChange={(e) => setFormData({ ...formData, password: e.target.value })}

                    />

                  </label>

                )}

                <div className="file-share-field">

                  <span className="file-share-label">Срок действия (необязательно)</span>

                  <div className="file-share-form-row">

                    <input

                      type="date"

                      className="form-input"

                      value={formData.expires_at}

                      onChange={(e) => setFormData({ ...formData, expires_at: e.target.value })}

                    />

                    <input

                      type="time"

                      className="form-input"

                      value={formData.expires_at_time}

                      onChange={(e) => setFormData({ ...formData, expires_at_time: e.target.value })}

                    />

                  </div>

                </div>

                <div className="file-share-form-actions">

                  <button type="submit" className="btn btn-primary">

                    <FiCheck /> {editingLink ? 'Сохранить' : 'Создать'}

                  </button>

                  <button type="button" className="btn btn-outline" onClick={resetForm}>

                    Отмена

                  </button>

                </div>

              </form>

            )}

          </section>



          <section className="file-share-section file-share-links">

            <h3 className="file-share-section-title">

              Существующие ссылки

              {!loading && links.length > 0 && (

                <span className="file-share-count">{links.length}</span>

              )}

            </h3>



            {loading ? (

              <div className="file-share-loading">Загрузка…</div>

            ) : links.length > 0 ? (

              <ul className="file-share-links-list">

                {links.map((link) => (

                  <li

                    key={link.id}

                    className={`file-share-link-item ${link.is_deleted ? 'is-deleted' : ''}`}

                  >

                    <div className="file-share-link-info">

                      <div className="file-share-link-name">{link.name}</div>

                      <div className="file-share-link-meta">

                        <span className={`file-share-badge ${link.has_password ? 'has-password' : ''}`}>

                          {link.has_password ? 'С паролем' : 'Без пароля'}

                        </span>

                        {link.expires_at && (

                          <span className="file-share-badge muted">

                            до {new Date(link.expires_at).toLocaleString('ru-RU', {

                              day: '2-digit',

                              month: 'short',

                              year: 'numeric',

                              hour: '2-digit',

                              minute: '2-digit',

                            })}

                          </span>

                        )}

                      </div>

                      {isModerator && link.created_by_email && (

                        <div className="file-share-link-author">{link.created_by_email}</div>

                      )}

                    </div>

                    <div className="file-share-link-actions">

                      <button

                        type="button"

                        className="file-share-icon-btn"

                        title="Копировать ссылку"

                        onClick={() => copyLink(link)}

                      >

                        <FiCopy />

                      </button>

                      {!link.is_deleted && (

                        <>

                          <button

                            type="button"

                            className="file-share-icon-btn"

                            title="Редактировать"

                            onClick={() => handleEdit(link)}

                          >

                            <FiEdit />

                          </button>

                          <button

                            type="button"

                            className="file-share-icon-btn danger"

                            title="Удалить"

                            onClick={() => handleDelete(link)}

                          >

                            <FiTrash2 />

                          </button>

                        </>

                      )}

                    </div>

                  </li>

                ))}

              </ul>

            ) : (

              <div className="file-share-empty">Ссылок пока нет — создайте первую</div>

            )}

          </section>

        </div>

      </div>

    </div>

  );

};



export default FileShareModal;


